import { useEffect } from 'react'

export const useDisableZoom = () => {
  useEffect(() => {
    const preventGesture = (e: Event) => e.preventDefault()
    const preventTouchZoom = (e: TouchEvent) => {
      if (e.touches.length > 1) {
        e.preventDefault()
      }
    }

    document.addEventListener('gesturestart', preventGesture)
    document.addEventListener('touchstart', preventTouchZoom, { passive: false })

    return () => {
      document.removeEventListener('gesturestart', preventGesture)
      document.removeEventListener('touchstart', preventTouchZoom)
    }
  }, [])
}
